import { animated } from 'react-spring';
import styled from 'styled-components';
import { Button } from '../../Button';
import { TextHint } from '../../Hint';
import { ArrowIcon } from '../../Icons';


export const CircleWrapper = styled(Button)`
  cursor: pointer;
  padding: 5px 0px;
  height: auto;
  width: 20px;
  margin-right: 2px;
  &:hover{
    background-color: transparent;
  }

  ${(props) => ({
    display: props.isBolded ? 'none' : '',
  })}
`;

export const Container = styled.div`
  background-color: ${(props) => props.theme.colors.UploadSurveyInputColor};
  border-radius: 10px;
  text-transform: uppercase;
  color: #6C6C6C;
  font-size: 1.2rem;
  line-height: 14px;
  border-width: 0;
  width: 100%;

  ${(props) => ({
    backgroundColor: props.isChecked ? props.theme.colors.UploadSurveyBackgroundActiveItem : 'transparent',
    border: !props.isCollapsed && !props.isChecked ? '1px solid #eaeaea' : '0',
  })}

  &:focus-within{
    ${CircleWrapper}{
      ${(props) => ({
    background: props.highlightFocusItem ? props.theme.colors.highlightFocusItem : 'transparent',
    borderRadius: props.highlightFocusItem ? '14px' : 0,
    padding: props.highlightFocusItem ? '3px' : '5px 0',
  })}
    }
  }
`;

export const Circle = styled.span`
  width: 9px;
  height: 9px;
  border-radius: 9px;
  border: 1px solid ${(props) => props.theme.colors.secondary};
  display: inline-block;

  ${(props) => ({
    background: props.isChecked ? '#00bec1' : 'transparent',
    border: props.isChecked ? 0 : `1px solid ${props.theme.collapsibleList.circleBorder}`,
    visibility: !props.isBolded ? 'visible' : 'hidden',
  })}
`;

export const Checkbox = styled.span`
  width: 9px;
  height: 9px;
  border-radius: 2.36px;
  border: 1px solid #00bec1;
  display: inline-block;
  margin-right: 17px;

  ${(props) => ({
    background: props.isChecked ? '#00bec1' : 'transparent',
    border: props.isChecked ? 0 : `1px solid ${props.theme.collapsibleList.circleBorder}`,
  })}
`;

export const CircleItem = styled.span`
  width: 9px;
  height: 9px;
  border-radius: 9px;
  border: 1px solid #6C6C6C;
  display: inline-block;
  margin-right: 5px;

  ${(props) => ({
    background: props.isChecked ? '#00bec1' : '#6C6C6C',
    border: props.isChecked ? 0 : '1px solid #6C6C6C',
  })}
`;

export const Arrow = styled(ArrowIcon)`
  vertical-align: bottom;
  overflow: hidden;
  margin-left: 18px;
  margin-right: 9.95px;

  ${(props) => ({
    color: props.isChecked ? props.theme.colors.ArrowIconCheckColor : props.theme.colors.ArrowIconUncheckColor,
  })}
`;

export const Head = styled.div`
  padding: ${(props) => (props.textPadding ? props.textPadding : '5px 20px 5px 8px')};
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 35px;

  &:hover {
    background: ${(props) => props.theme.collapsibleList.itemHoverBackground};
    border-radius: 10px;
  }
`;

export const Collapser = styled(Button)`
  cursor: pointer;
  padding: 5px 0px;
  height: auto;
  overflow: hidden;
  align-items: center;
  display: inline-flex;
  color: inherit;
  max-width: 95%;
  @media (max-width: 586px) {
    max-width: 88%;
  }
  &:hover{
    background-color: transparent;
  }
`;

export const Text = styled.span`
  overflow: hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
  display:inline-block;
  width: 85%;
  flex: 1;
  text-transform: none;
  color: ${(props) => props.theme.collapsibleList.textColor};
`;

export const Title = styled(Text)`
text-transform: ${(props) => (props.isUpperCase ? 'uppercase' : 'initial')};
  ${(props) => ({
    color: props.isBolded ? props.theme.collapsibleList.titleColorBolded : props.theme.collapsibleList.titleColorUnBolded,
    fontWeight: props.isBolded ? 'bold' : 'inherit',
  })}
`;

export const TextWithHint = styled(TextHint)`
  ${(props) => ({
    color: props.isBolded ? '#610082' : 'inherit',
    fontWeight: props.isBolded ? 'bold' : 'inherit',
  })}
  overflow: hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
  display:inline-block;
  width: 85%;
  flex: 1;
`;

export const Body = styled(animated.div)`
  overflow: hidden;
  padding: 0px 20px;
  padding-bottom: 5px;
  height: 100% !important;
`;

export const Items = styled.div`
  padding: 0px 24px;
  align-items: center;
  gap: 2%;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

export const ItemsEmpty = styled.div`
  padding: 0px 24px;
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100px;
`;

export const Item = styled(Button)`
  cursor: pointer;
  width: calc(94% / 3);
  padding: 7px 7px;
  overflow: hidden;
  align-items: baseline;
  display: flex;
  color: inherit;
  height: auto;
  text-align: start;
`;

export const FixedItem = styled.div`
  width: calc(94% / 3);
  padding: 6.2px 7px;
  overflow: hidden;
  align-items: baseline;
  display: flex;
  color: inherit;
  height: auto;
  text-align: start;
`;

export const ConsolidationWrapper = styled(FixedItem)`
  background-color: ${({theme}) => theme.colors.backgroundColorcomponent};
  color: ${({ theme }) => theme.colors.normalConsolidationTextLabelColor};
  border-left: 1px solid ${({ theme }) => theme.colors.normalConsolidationTextLabelColor};
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 2px;
  text-transform: initial;
  user-select: none;
`;

export const ConsolidationActionGroup = styled.div`
  min-width: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  & .icon {
    cursor: pointer;
    fill: ${({ theme }) => theme.colors.normalConsolidationIconColor};
  }
`;